import { createContext } from "react";
import { IEntrega, IObra, IPecaParaEntrega, TipoOperacao } from "../views/Obras/newObra/IObra";

export type ISelectionValues = {
    obra: Partial<IObra> | null, entrega: Partial<IEntrega> | null, operacao: TipoOperacao | null, pecaEntrega: Partial<IPecaParaEntrega> | null
}

export const FactoryFloorContext = createContext<{selectionValues: ISelectionValues, setSelectionValues: Function}>({ selectionValues:  {obra: null, entrega: null, operacao: null, pecaEntrega: null}, setSelectionValues: () => null})